"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.areEqual = exports.externalLinkSelector = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var externalLinkSelector = urls => {
  var valid = [];
  urls.forEach(url => {
    try {
      // we need to transform urls into `hostname/pathname` - strip protocol and query info
      var {
        hostname,
        pathname
      } = new URL(url);
      valid.push("".concat(hostname).concat(pathname));
    } catch (_unused) {// do nothing
    }
  });
  return "& a[href*=\"//\"]".concat(valid.map(url => ":not([href*=\"".concat(url, "\"])")).join(''));
};

exports.externalLinkSelector = externalLinkSelector;
var useLinkStyles = (0, _styles.makeStyles)(() => ({
  '@global': {
    '.jodit-wysiwyg': props => ({
      [externalLinkSelector(props.urls)]: {
        '&::after': {
          width: props.size,
          height: props.size,
          display: 'inline-block',
          content: props.content,
          paddingLeft: props.gap,
          color: props.color
        }
      }
    })
  }
}), {
  name: 'rich-text-links'
});

var OverrideLinkStyles = (_ref) => {
  var {
    size = '1em',
    gap = 3,
    urls,
    icon,
    color
  } = _ref;
  var svg = (0, _fontawesomeSvgCore.icon)(icon, {
    styles: {
      color
    }
  });
  var content = (svg === null || svg === void 0 ? void 0 : svg.html) ? "url('data:image/svg+xml; utf8, ".concat(svg.html[0].replace('#', '%23'), "')") : "\"".concat(icon, "\"");
  useLinkStyles({
    size,
    gap,
    urls,
    content,
    color
  });
  return null;
};

OverrideLinkStyles.propTypes = {
  /**
   * List of internal urls
   */
  urls: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,

  /**
   * Fortawesome icon or text
   */
  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    // eslint-disable-next-line react/forbid-prop-types
    icon: _propTypes.default.array,
    iconName: _propTypes.default.string,
    prefix: _propTypes.default.string
  })]).isRequired,

  /**
   * Gap between link and icon
   */
  gap: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Size of icon
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Color of icon
   */
  color: _propTypes.default.string
}; // shallowEqual with additionally checking for arrays

var areEqual = (prevProps, nextProps) => {
  var prevKeys = Object.keys(prevProps);
  var nextKeys = Object.keys(nextProps);

  if (prevKeys.length !== nextKeys.length) {
    return false;
  } // eslint-disable-next-line no-plusplus


  var _loop = function _loop(idx, idxMax) {
    var key = prevKeys[idx]; // eslint-disable-next-line no-prototype-builtins

    if (!nextProps.hasOwnProperty(key)) {
      return {
        v: false
      };
    }

    var prevValue = prevProps[key];
    var nextValue = nextProps[key];

    if (prevValue === nextValue) {
      // eslint-disable-next-line no-continue
      return "continue";
    }

    if (!(Array.isArray(prevValue) && Array.isArray(nextValue) && prevValue.length === nextValue.length && prevValue.every((val, index) => val === nextValue[index]))) {
      return {
        v: false
      };
    }
  };

  for (var idx = 0, idxMax = prevKeys.length; idx < idxMax; idx++) {
    var _ret = _loop(idx, idxMax);

    if (_ret === "continue") continue;
    if (typeof _ret === "object") return _ret.v;
  }

  return true;
};

exports.areEqual = areEqual;

var _default = /*#__PURE__*/_react.default.memo(OverrideLinkStyles, areEqual);

exports.default = _default;